export default __webpack_public_path__ + "assets/fabf16c6e3e624169504deb05609087a.png";